// =============================================================================
// STORES PAGES LAYOUTS
// =============================================================================

import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'warehouses',
  component: () => import('../../views/admin/warehouses/warehousesList/index'),
  children: [
    {
      path: '',
      name: 'warehousesList',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehousesList" */ '@/mobile/views/admin/warehouses/warehousesList/list/warehousesList.vue') : import(/* webpackChunkName: "desktopWarehousesList" */ '@/desktop/views/admin/warehouses/warehousesList/list/warehousesList.vue') },
      meta: {
        permission: 'storeroom.show',
        pageTitle: '',
        pageTitleI18n: 'pages.warehousing.warehouses.list.title'
      // rule: 'editor'
      }
    },
    {
      path: 'trash',
      name: 'warehousesTrash',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehousesTrash" */ '@/mobile/views/admin/warehouses/warehousesList/trash/warehousesTrash.vue') : import(/* webpackChunkName: "desktopWarehousesTrash" */ '@/desktop/views/admin/warehouses/warehousesList/trash/warehousesTrash.vue') },
      meta: {
        permission: ['storeroom.show', 'storeroom.forceDelete', 'storeroom.restore'],
        pageTitle: '',
        pageTitleI18n: 'pages.warehousing.warehouses.trash.title'
      // rule: 'editor'
      }
    },
    {
      path: 'str-:id',
      component: () => { return isMobile() ?  import('@/mobile/views/admin/warehouses/warehousesList/warehouse/index.vue') : import('@/desktop/views/admin/warehouses/warehousesList/warehouse/index.vue') },
      meta: {
        redirectNotFound: true
      },
      children: [
        {
          path: '',
          name: 'warehouse',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouse" */ '@/mobile/views/admin/warehouses/warehousesList/warehouse/profile/warehouseMenu.vue') : import(/* webpackChunkName: "desktopWarehouse" */ '@/desktop/views/admin/warehouses/warehousesList/warehouse/profile/warehouseMenu.vue') },
          meta: {
            permission: 'storeroom.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.warehouses.store.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        },
        {
          path: 'edit',
          name: 'editWarehouse',
          component: () => import(/* webpackChunkName: "editStore" */ '../../views/admin/warehouses/warehousesList/warehouse/edit/editWarehouse.vue'),
          meta: {
            permission: 'storeroom.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.warehouses.edit.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        },
        {
          path: 'transactions',
          name: 'warehouseTransactions',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTransactions" */ '@/mobile/views/admin/warehouses/warehousesList/warehouse/transactions/warehouseTransactions.vue') : import(/* webpackChunkName: "desktopWarehouseTransactions" */ '@/desktop/views/admin/warehouses/warehousesList/warehouse/transactions/warehouseTransactions.vue') },
          meta: {
            permission: 'storeroom.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.warehouses.transactions.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        },
        {
          path: 'turnover',
          name: 'warehouseTurnover',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTurnover" */ '@/mobile/views/admin/warehouses/warehousesList/warehouse/turnover/warehouseTurnover.vue') : import(/* webpackChunkName: "desktopWarehouseTurnover" */ '@/desktop/views/admin/warehouses/warehousesList/warehouse/turnover/warehouseTurnover.vue') },
          meta: {
            permission: 'storeroom.turnover',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.turnover.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        },
        {
          path: 'inventory',
          name: 'warehouseInventory',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseInventory" */ '@/mobile/views/admin/warehouses/warehousesList/warehouse/inventory/warehousesInventory.vue') : import(/* webpackChunkName: "desktopWarehouseInventory" */ '@/desktop/views/admin/warehouses/warehousesList/warehouse/inventory/warehousesInventory.vue') },
          meta: {
            permission: 'storeroom.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.inventory.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        },
        {
          path: 'inventory-valuation',
          name: 'warehouseInventoryValuation',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseInventoryValuation" */ '@/mobile/views/admin/warehouses/warehousesList/warehouse/inventory/warehousesInventory.vue') : import(/* webpackChunkName: "desktopWarehouseInventoryValuation" */ '@/desktop/views/admin/warehouses/warehousesList/warehouse/inventory/warehousesInventory.vue') },
          meta: {
            permission: 'storeroom.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.inventoryValuation.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        },
        {
          path: 'activities-log',
          name: 'warehouseActivitiesLog',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseActivitiesLog" */ '@/mobile/views/admin/warehouses/warehousesList/warehouse/activitiesLog/warehouseActivitiesLog.vue') : import(/* webpackChunkName: "desktopWarehouseActivitiesLog" */ '@/desktop/views/admin/warehouses/warehousesList/warehouse/activitiesLog/warehouseActivitiesLog.vue') },
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های انبار',
            pageTitleI18n: 'pages.warehousing.warehouses.logs.title',
            layoutStatus: 'profile'
          // rule: 'editor'
          }
        }
      ]
    },
    {
      path: 'insert',
      name: 'InsertWarehouse',
      component: () => import(/* webpackChunkName: "InsertWarehouse" */ '../../views/admin/warehouses/warehousesList/insert/insertWarehouse.vue'),
      meta: {
        permission: 'storeroom.create',
        pageTitleI18n: 'pages.warehousing.warehouses.insert.title'
      // rule: 'editor'
      }
    },
    {
      path: 'inventory',
      name: 'warehousesInventory',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehousesInventory" */ '@/mobile/views/admin/warehouses/inventory/warehousesInventory.vue') : import(/* webpackChunkName: "desktopWarehousesInventory" */ '@/desktop/views/admin/warehouses/inventory/warehousesInventory.vue') },
      meta: {
        permission: 'storeroom.inventory',
        pageTitle: '',
        pageTitleI18n: 'pages.warehousing.inventory.title'
      // rule: 'editor'
      }
    },
    {
      path: 'turnover',
      name: 'warehousesTurnover',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehousesInventoryTurnover" */ '@/mobile/views/admin/warehouses/turnover/warehousesTurnover.vue') : import(/* webpackChunkName: "desktopWarehousesInventoryTurnover" */ '@/desktop/views/admin/warehouses/turnover/warehousesTurnover.vue') },
      meta: {
        permission: 'storeroom.turnover',
        pageTitle: '',
        pageTitleI18n: 'pages.warehousing.turnover.title'
      // rule: 'editor'
      }
    },
    {
      path: 'inventory-valuation',
      name: 'warehousesInventoryValuation',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehousesInventoryValuation" */ '@/mobile/views/admin/warehouses/inventory/warehousesInventory.vue') : import(/* webpackChunkName: "desktopWarehousesInventoryValuation" */ '@/desktop/views/admin/warehouses/inventory/warehousesInventory.vue') },
      meta: {
        permission: 'storeroom.inventoryValuation',
        pageTitle: '',
        pageTitleI18n: 'pages.warehousing.inventoryValuation.title'
      // rule: 'editor'
      }
    },
    {
      path: 'receipts',
      component: () => import(/* webpackChunkName: "receipts" */ '../../views/admin/warehouses/receipts/index'),
      children: [
        {
          path: '',
          name: 'warehouseReceipts',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseReceipts" */ '@/mobile/views/admin/warehouses/receipts/list/warehouseReceiptsList.vue') : import(/* webpackChunkName: "desktopWarehouseReceipts" */ '@/desktop/views/admin/warehouses/receipts/list/warehouseReceiptsList.vue') },
          meta: {
            permission: 'storeroom_receipt.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.receipts.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertWarehouseReceipt',
          component: () => import(/* webpackChunkName: "insertWarehouseReceipt" */ '../../views/admin/warehouses/receipts/insert/insertWarehouseReceipt.vue'),
          meta: {
            permission: 'storeroom_receipt.create',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.receipts.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => import('../../views/admin/warehouses/receipts/receipt/index'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'warehouseReceipt',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseReceipt" */ '@/mobile/views/admin/warehouses/receipts/receipt/warehouseReceipt.vue') : import(/* webpackChunkName: "desktopWarehouseReceipt" */ '@/desktop/views/admin/warehouses/receipts/receipt/warehouseReceipt.vue') },
              meta: {
                permission: 'storeroom_receipt.show',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.receipts.receipt.title'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editWarehouseReceipt',
              component: () => import(/* webpackChunkName: "editWarehouseReceipt" */ '../../views/admin/warehouses/receipts/edit/editWarehouseReceipt.vue'),
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'ویرایش حواله انبار',
                pageTitleI18n: 'pages.warehousing.receipts.edit.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'warehouseReceiptActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseReceiptActivitiesLog" */ '@/mobile/views/admin/warehouses/receipts/receipt/activitiesLog/warehouseReceiptActivitiesLog.vue') : import(/* webpackChunkName: "desktopWarehouseReceiptActivitiesLog" */ '@/desktop/views/admin/warehouses/receipts/receipt/activitiesLog/warehouseReceiptActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های حواله انبار',
                pageTitleI18n: 'pages.warehousing.receipts.receipt.logs.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'deficits',
      component: () => import(/* webpackChunkName: "deficit" */ '../../views/admin/warehouses/deficits/index'),
      children: [
        {
          path: '',
          name: 'warehouseDeficitsList',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseDeficitsList" */ '@/mobile/views/admin/warehouses/deficits/list/warehouseDeficitsList.vue') : import(/* webpackChunkName: "desktopWarehouseDeficitsList" */ '@/desktop/views/admin/warehouses/deficits/list/warehouseDeficitsList.vue') },
          meta: {
            permission: 'storeroom_deficit.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.deficit.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'warehouseDeficitsTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseDeficitsTrash" */ '@/mobile/views/admin/warehouses/deficits/trash/warehouseDeficitsTrash.vue') : import(/* webpackChunkName: "desktopWarehouseDeficitsTrash" */ '@/desktop/views/admin/warehouses/deficits/trash/warehouseDeficitsTrash.vue') },
          meta: {
            permission: ['storeroom_deficit.show', 'storeroom_deficit.forceDelete', 'storeroom_deficit.restore'],
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.deficit.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'warehouseDeficitTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseDeficitTrashProfile" */ '@/mobile/views/admin/warehouses/deficits/profile/warehouseDeficitProfile.vue') : import(/* webpackChunkName: "desktopWarehouseDeficitTrashProfile" */ '@/desktop/views/admin/warehouses/deficits/profile/warehouseDeficitProfile.vue') },
          meta: {
            permission: 'storeroom_deficit.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.deficit.profile.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertWarehouseDeficit',
          component: () => import(/* webpackChunkName: "insertWarehouseDeficit" */ '../../views/admin/warehouses/deficits/insert/insertWarehouseDeficit.vue'),
          meta: {
            permission: 'storeroom_deficit.create',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.deficit.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => import('../../views/admin/warehouses/deficits/index'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'warehouseDeficit',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseDeficit" */ '@/mobile/views/admin/warehouses/deficits/profile/warehouseDeficitProfile.vue') : import(/* webpackChunkName: "desktopWarehouseDeficit" */ '@/desktop/views/admin/warehouses/deficits/profile/warehouseDeficitProfile.vue') },
              meta: {
                permission: 'storeroom_deficit.show',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.deficit.profile.title'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editWarehouseDeficit',
              component: () => import(/* webpackChunkName: "editWarehouseDeficit" */ '../../views/admin/warehouses/deficits/edit/editWarehouseDeficit.vue'),
              meta: {
                permission: 'storeroom_deficit.update',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.deficit.edit.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'warehouseDeficitActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseDeficitActivitiesLog" */ '@/mobile/views/admin/warehouses/deficits/activitiesLog/warehouseDeficitActivitiesLog.vue') : import(/* webpackChunkName: "desktopWarehouseDeficitActivitiesLog" */ '@/desktop/views/admin/warehouses/deficits/activitiesLog/warehouseDeficitActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های حواله انبار',
                pageTitleI18n: 'pages.warehousing.deficit.logs.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'conversions',
      component: () => import(/* webpackChunkName: "conversions" */ '../../views/admin/warehouses/conversions/index'),
      children: [
        {
          path: '',
          name: 'warehouseConversionsList',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseConversionsList" */ '@/mobile/views/admin/warehouses/conversions/list/warehouseConversionsList.vue') : import(/* webpackChunkName: "desktopWarehouseConversionsList" */ '@/desktop/views/admin/warehouses/conversions/list/warehouseConversionsList.vue') },
          meta: {
            permission: 'storeroom_conversion.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.conversion.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'warehouseConversionsTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseConversionsTrash" */ '@/mobile/views/admin/warehouses/conversions/trash/warehouseConversionsTrash.vue') : import(/* webpackChunkName: "desktopWarehouseConversionsTrash" */ '@/desktop/views/admin/warehouses/conversions/trash/warehouseConversionsTrash.vue') },
          meta: {
            permission: ['storeroom_conversion.show', 'storeroom_conversion.forceDelete', 'storeroom_conversion.restore'],
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.conversion.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'warehouseConversionTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseConversionTrashProfile" */ '@/mobile/views/admin/warehouses/conversions/profile/warehouseConversionsProfile.vue') : import(/* webpackChunkName: "desktopWarehouseConversionTrashProfile" */ '@/desktop/views/admin/warehouses/conversions/profile/warehouseConversionsProfile.vue') },
          meta: {
            permission: 'storeroom_conversion.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.conversion.profile.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertWarehouseConversion',
          component: () => import(/* webpackChunkName: "insertWarehouseConversion" */ '../../views/admin/warehouses/conversions/insert/insertWarehouseConversions.vue'),
          meta: {
            permission: 'storeroom_conversion.create',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.conversion.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => import('../../views/admin/warehouses/conversions/index'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'warehouseConversion',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseConversion" */ '@/mobile/views/admin/warehouses/conversions/profile/warehouseConversionsProfile.vue') : import(/* webpackChunkName: "desktopWarehouseConversion" */ '@/desktop/views/admin/warehouses/conversions/profile/warehouseConversionsProfile.vue') },
              meta: {
                permission: 'storeroom_conversion.show',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.conversion.profile.title'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editWarehouseConversion',
              component: () => import(/* webpackChunkName: "editWarehouseConversion" */ '../../views/admin/warehouses/conversions/edit/editWarehouseConversions.vue'),
              meta: {
                permission: 'storeroom_conversion.update',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.conversion.edit.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'warehouseConversionActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseConversionActivitiesLog" */ '@/mobile/views/admin/warehouses/conversions/activitiesLog/warehouseConversionsActivitiesLog.vue') : import(/* webpackChunkName: "desktopWarehouseConversionActivitiesLog" */ '@/desktop/views/admin/warehouses/conversions/activitiesLog/warehouseConversionsActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های حواله انبار',
                pageTitleI18n: 'pages.warehousing.conversion.logs.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'transfers',
      component: () => import(/* webpackChunkName: "transfers" */ '../../views/admin/warehouses/transfers/index'),
      children: [
        {
          path: '',
          name: 'warehouseTransfersList',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTransfersList" */ '@/mobile/views/admin/warehouses/transfers/list/warehouseTransfersList.vue') : import(/* webpackChunkName: "desktopWarehouseTransfersList" */ '@/desktop/views/admin/warehouses/transfers/list/warehouseTransfersList.vue') },
          meta: {
            permission: 'storeroom_transfer.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.transfer.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'warehouseTransfersTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTransfersTrash" */ '@/mobile/views/admin/warehouses/transfers/trash/warehouseTransfersTrash.vue') : import(/* webpackChunkName: "desktopWarehouseTransfersTrash" */ '@/desktop/views/admin/warehouses/transfers/trash/warehouseTransfersTrash.vue') },
          meta: {
            permission: ['storeroom_transfer.show', 'storeroom_transfer.forceDelete', 'storeroom_transfer.restore'],
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.transfer.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'warehouseTransferTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTransferTrashProfile" */ '@/mobile/views/admin/warehouses/transfers/profile/warehouseTransferProfile.vue') : import(/* webpackChunkName: "desktopWarehouseTransferTrashProfile" */ '@/desktop/views/admin/warehouses/transfers/profile/warehouseTransferProfile.vue') },
          meta: {
            permission: 'storeroom_transfer.show',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.transfer.profile.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertWarehouseTransfer',
          component: () => import(/* webpackChunkName: "insertWarehouseTransfer" */ '../../views/admin/warehouses/transfers/insert/insertWarehouseTransfer.vue'),
          meta: {
            permission: 'storeroom_transfer.create',
            pageTitle: '',
            pageTitleI18n: 'pages.warehousing.transfer.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => import('../../views/admin/warehouses/transfers/index'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'warehouseTransfer',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTransfer" */ '@/mobile/views/admin/warehouses/transfers/profile/warehouseTransferProfile.vue') : import(/* webpackChunkName: "desktopWarehouseTransfer" */ '@/desktop/views/admin/warehouses/transfers/profile/warehouseTransferProfile.vue') },
              meta: {
                permission: 'storeroom_transfer.show',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.transfer.profile.title'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editWarehouseTransfer',
              component: () => import(/* webpackChunkName: "editWarehouseTransfer" */ '../../views/admin/warehouses/transfers/edit/editWarehouseTransfer.vue'),
              meta: {
                permission: 'storeroom_transfer.update',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.transfer.edit.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'warehouseTransferActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileWarehouseTransferActivitiesLog" */ '@/mobile/views/admin/warehouses/transfers/activitiesLog/warehouseTransferActivitiesLog.vue') : import(/* webpackChunkName: "desktopWarehouseTransferActivitiesLog" */ '@/desktop/views/admin/warehouses/transfers/activitiesLog/warehouseTransferActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: '',
                pageTitleI18n: 'pages.warehousing.transfer.logs.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    }
  ]
}
